// 各頁面原本硬編中文抽出的詞條（CB7REQ-170）；key 為語言中性，四語系同步維護
export default {
  "pageText.activity.memberAccountOrPhone": "会员账号 / 手机号",
  "pageText.activity.freeCheckinPoints": "免费签到发放积分",
  "pageText.activity.depositCheckinPoints": "存款签到发放积分",
  "pageText.activity.unit": "单位",
  "pageText.activity.issueQty": "发放数量",
  "pageText.activity.treasureIssuePHP": "宝箱发放（PHP）",
  "pageText.activity.treasureIssueUSDT": "宝箱发放（USDT）",
  "pageText.activity.treasureIssueVND": "宝箱发放（VND）",
  "pageText.activity.treasureClaimPHP": "宝箱领取（PHP）",
  "pageText.activity.treasureClaimUSDT": "宝箱领取（USDT）",
  "pageText.activity.treasureClaimVND": "宝箱领取（VND）",
  "pageText.activity.treasureExpirePHP": "宝箱过期（PHP）",
  "pageText.activity.treasureExpireUSDT": "宝箱过期（USDT）",
  "pageText.activity.treasureExpireVND": "宝箱过期（VND）",
  "pageText.activity.qtyMustBePositive": "数量必须大于0",
  "pageText.activity.maxValue": "最大值",
  "pageText.activity.minValue": "最小值",
  "pageText.activity.maxAmountGteMin": "最大金额必须 >= 最小金额",
  "pageText.activity.idRequired": "未填入id",
  "pageText.activity.actPkRequired": "活动数据主键码不能为空，请先加载活动配置",
  "pageText.activity.filter": "筛选",
  "pageText.activity.queryUserStatusFirst": "请先查询用户状态",
  "pageText.activity.bonusRangesRequired100": "请先配齐彩金区间且概率合计 100%",
  "pageText.activity.uploadAtLeastOneImage": "请至少上传一张图片",
  "pageText.activity.addAtLeastOneBonusRange": "请至少添加一个彩金区间",
  "pageText.activity.enterIssueQty": "请输入发放数量",
  "pageText.activity.selectItemType": "选择事项类型",
  "pageText.activity.accountsSemicolonHint": "（用;分隔多个账号）",
  "pageText.activity.fileMax50MB": "檔案不能超過 50MB！",
  "pageText.financial.failCountLimit5Min": "5 分钟失败次数上限",
  "pageText.financial.eg10": "例如 10",
  "pageText.financial.eg10000": "例如 10000.00",
  "pageText.financial.eg500": "例如 500.00",
  "pageText.financial.singlePayLimit": "单笔支付上限",
  "pageText.financial.paramSetFailed": "参数设置失败",
  "pageText.financial.paramSetSuccess": "参数设置成功",
  "pageText.financial.paramConfigFailed": "参数配置失败",
  "pageText.financial.paramConfigSuccess": "参数配置成功",
  "pageText.financial.teamsGroupHint": "填写 Teams 群组名称或 webhook URL",
  "pageText.financial.rejectFailed": "拒绝操作失败",
  "pageText.financial.payTypeCode": "支付类型代码",
  "pageText.financial.payTypeName": "支付类型名称",
  "pageText.financial.channelNotFound": "未找到渠道信息",
  "pageText.financial.payingInProgress": "正在出款中",
  "pageText.financial.dailyPayLimit": "每日支付上限",
  "pageText.financial.confirmDeletePayType": "确定要删除这个支付类型吗？",
  "pageText.financial.confirmRechargeFailed": "确认充值失败",
  "pageText.financial.confirmRechargeSuccess": "确认充值成功",
  "pageText.financial.autoPayoutSwitch": "自动代付开关",
  "pageText.financial.autoPayoutSort": "自动代付排序",
  "pageText.financial.getPayChannelListFailed": "获取代付渠道列表失败",
  "pageText.financial.getPayChannelDataFailed": "获取代付渠道数据失败",
  "pageText.financial.getParamSetFailed": "获取参数设置失败",
  "pageText.financial.getPayTypeDataFailed": "获取支付类型数据失败",
  "pageText.financial.getCurrencyListFailed": "获取货币类型列表失败",
  "pageText.financial.unlockFailed": "解锁失败",
  "pageText.financial.unlockSuccess": "解锁成功",
  "pageText.financial.enterPayTypeCode": "请输入支付类型代码",
  "pageText.financial.enterPayTypeName": "请输入支付类型名称",
  "pageText.financial.enterAmountMax2Decimals": "请输入最多两位小数的金额",
  "pageText.financial.notifyGroup": "通知群组",
  "pageText.financial.lockFailed": "锁定失败",
  "pageText.financial.lockSuccess": "锁定成功",
  "pageText.luckySpin.effectImmediately": "✓ 立即生效",
  "pageText.luckySpin.validSameDayOnly": "仅当日有效",
  "pageText.luckySpin.validSameDayOnlyDetail": "仅当日有效，次日凌晨0:00失效",
  "pageText.luckySpin.withinValid": "内有效",
  "pageText.luckySpin.multiLangConfigExternal": "多语言配置（外部显示）",
  "pageText.luckySpin.daysHoursNotBothZero": "天数和小时不能都为0",
  "pageText.luckySpin.hourRange": "小时范围：0-23",
  "pageText.luckySpin.hourUnit": "时",
  "pageText.luckySpin.effectNextDayMidnight": "次日凌晨0:00生效",
  "pageText.luckySpin.selectAfterClaimMode": "请选择领取后模式",
  "pageText.luckySpin.afterClaim": "领取后",
  "pageText.luckySpin.afterClaimMode": "领取后模式",
  "pageText.member.anchor": "主播",
  "pageText.member.tradeRangeMax7Days": "帳變時間範圍不能超過7天",
  "pageText.member.lastOnlineTime": "最后在线时间：",
  "pageText.member.lastDepositTime": "最后存款时间：",
  "pageText.member.registerTime": "注册时间：",
  "pageText.member.loginDomain": "登录域名：",
  "pageText.member.getWalletAccountsFailed": "获取钱包账户列表失败",
  "pageText.member.getBankCardsFailed": "获取银行卡列表失败",
  "pageText.member.requestFailed": "請求失敗",
  "pageText.member.resetWithdrawPwdError": "重置提现密码出错",
  "pageText.member.resetLoginPwdError": "重置登录密码出错",
  "pageText.member.firstDepositTime": "首存时间：",
  "pageText.sys.createRole": "創建角色",
  "pageText.sys.failed": "失敗",
  "pageText.sys.opFailedRetry": "操作失败，请重试",
  "pageText.sys.dataLoadFailed": "數據加載失敗",
  "pageText.sys.memberAccount": "會員帳號",
  "pageText.sys.messageContent": "消息內容",
  "pageText.sys.updateFailed": "更新失败",
  "pageText.sys.addFailed": "添加失败",
  "pageText.seo.featureInDevelopment": "功能开发中...",
  "pageText.seo.monthlyImpressions": "月曝光量",
  "pageText.seo.monthlyImpressionsGsc": "月曝光量(gsc)",
  "pageText.sms.enterSenderId": "请输入 Sender ID",
  "pageText.sms.countryUS": "US - 美国",
  "pageText.risk.supKycPkMissing": "缺少 supDataPkCode（补充KYC主键），无法提交审核",
  "pageText.risk.supKycNotFound": "补充KYC信息不存在",
  "pageText.risk.supKycMemberMissing": "补充KYC信息会员id不存在",
  "pageText.risk.formValidateFailed": "表单验证失败，请检查必填项",
  "pageText.inbox.startDateTime": "开始日期时间",
  "pageText.inbox.endDateTime": "结束日期时间",
  "pageText.common.loading": "加载中...",
  "pageText.common.noData": "暂无数据",
  "pageText.common.unknown": "未知",
  "pageText.common.filter": "筛选",
  "pageText.common.allAgents": "全部代理",
  "pageText.activity.eggReady": "待孵化",
  "pageText.activity.hatchedNoEnergy": "已孵化（无体力）",
  "pageText.activity.eg24000": "例如 24000",
  "pageText.activity.onlyTopTier": "仅最高档可填",
  "pageText.financial.editPayType": "编辑支付类型",
  "pageText.financial.addPayType": "添加支付类型",
  "pageText.financial.getDataFailed": "获取数据失败",
  "pageText.financial.changePayChannelFailed": "修改代付渠道失败",
  "pageText.risk.rejectFailed": "拒绝失败",
  "pageText.member.streamerUser": "主播用户",
  "pageText.member.patrolUser": "巡查用户",
  "pageText.member.normalUser": "普通用户",
  "pageText.member.gameCategory3DHall": "3D厅",
  "pageText.common.autoLogout": "自动注销",
  "pageText.common.stay": "留下",
  "pageText.common.leave": "再会",
  "pageText.common.autoLogoutReason": "为避免不肖人士在您离开计算机时进行恶意操作",
  "pageText.common.autoLogoutStayHint": "要保持登入状态，请按下 \"留下\"",
  "pageText.common.scrollToTop": "滚动到顶部",
  "pageText.common.scrollToBottom": "滚动到底部",
  "pageText.common.uploadTimeout": "上传超时",
  "pageText.common.imageUploadFailed": "图片上传失败",
  "pageText.common.uploadingImage": "正在上传图片...",
  "pageText.common.enterContent": "请输入内容...",
  "pageText.common.selectAll": "全選",
  "pageText.common.selectVipLevel": "請選擇VIP等級",
  "pageText.common.uploadSuccess": "上傳成功",
  "pageText.common.uploadFailed": "上傳失敗",
  "pageText.common.metaDescPreview": "Meta Description 将在这里显示…"
};
